import React from 'react';

import {Modal, Box} from '@mui/material';

import ProgressIndicator, {ProgressIndicatorProps} from './ProgressIndicator';

export default function ProgressModal(props: ProgressIndicatorProps) {
    const handleClose = React.useCallback((_, reason) => {
        if (reason !== 'backdropClick') {
            //handleModalClose(props);
        }
    }, []);

    if (props.show === false) return <></>;

    return (
        <Modal open={true} onClose={handleClose}>
            <Box
                sx={[
                    {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        //border: '2px solid #000',
                        //boxShadow: 24,
                        boxShadow: theme_.dialog.boxShadow,
                        p: 4,
                    },
                    theme_.dialog.border ? theme_.dialog.border.sx() : {},
                    theme_.dialog.background ? theme_.dialog.background.css() : {},
                ]}
            >
                <ProgressIndicator {...props} />
            </Box>
        </Modal>
    );
}
